import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import {
  getAllPaymentsInitiate,
  getPaymentDebitsInitiate,
} from '../../actions/payments';
import Payments from './Payments';
import {
  openErrorToast,
  openSuccessToast,
  openWarningToast,
} from '../../reducers/uiLogic';
import { refreshAuthInitiate } from '../../actions/auth';
import { currentFlowTypeEnum } from '../common/components/constants';

const mapStateToProps = state => {
  const paymentsData = _get(state, 'payments.paymentsData', {});
  const paymentDebitsData = _get(state, 'payments.paymentDebitsData', []);
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const isOnlinePaymentsEnabled = _get(
    state,
    'user.supported_features.online_payments_enabled',
    false,
  );
  const currentFlow = _get(
    state,
    'user.currentFlow',
    currentFlowTypeEnum.FLOW_TYPE_PPI,
  );
  return {
    currentFlow,
    isOnlinePaymentsEnabled,
    paymentsData,
    selectedWorkspace,
    fetchingPayments:
      _get(state, 'apiState.GET_PAYMENTS.isFetching', true) &&
      !_get(state, 'apiState.GET_PAYMENTS.isIdle', false),
    fetchedPayments: _get(state, 'apiState.GET_PAYMENTS.success', true),
    paymentDebitsData,
    fetchingPaymentDebits:
      _get(state, 'apiState.GET_PAYMENT_DEBITS.isFetching', true) &&
      !_get(state, 'apiState.GET_PAYMENT_DEBITS.isIdle', false),
    fetchedPaymentDebits: _get(
      state,
      'apiState.GET_PAYMENT_DEBITS.success',
      true,
    ),
    refreshingAuth:
      _get(state, 'apiState.REFRESH_AUTH.isFetching', false) &&
      !_get(state, 'apiState.REFRESH_AUTH.isIdle', true),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllPayments: payload => dispatch(getAllPaymentsInitiate(payload)),
  getPaymentDebits: payload => dispatch(getPaymentDebitsInitiate(payload)),
  showWarningToast: message => dispatch(openWarningToast(message)),
  showSuccessToast: message => dispatch(openSuccessToast(message)),
  showFailedToast: message => dispatch(openErrorToast(message)),
  refreshAuth: () => dispatch(refreshAuthInitiate()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Payments);
